export enum Feature {
    NoteRequiredWhenCompletingActionPoint,
    ActionCoordinatorRole,
    EmployeesMayViewDocuments,
    ActionPointExecutor
}
